import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import Layout from './components/Layout/Layout';
import Login from './pages/Login';
import AicisDashboard from './pages/AicisDashboard';
import AbvigDashboard from './pages/AbvigDashboard';
import DiplomaticSignIn from './pages/Aicis/DiplomaticSignIn';
import Speakers from './pages/Aicis/Speakers';
import EventRegistrations from './pages/Aicis/EventRegistrations';
import AffiliatePurchases from './pages/Aicis/AffiliatePurchases';
import Settings from './pages/Aicis/Settings';  // <- Updated path
import ContactMessages from './pages/Abvig/ContactMessages';
import InternApplications from './pages/Abvig/InternApplications';
import Partnerships from './pages/Abvig/Partnerships';
import Subscribers from './pages/Abvig/Subscribers';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-50">
          <Toaster position="top-right" />
          <Routes>
            {/* Login Page - No Layout */}
            <Route path="/login" element={<Login />} />
            
            {/* Protected Routes with Layout */}
            <Route path="/" element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }>
              <Route index element={<Navigate to="/aicis" replace />} />
              <Route path="aicis" element={<AicisDashboard />} />
              <Route path="aicis/diplomatic-signin" element={<DiplomaticSignIn />} />
              <Route path="aicis/speakers" element={<Speakers />} />
              <Route path="aicis/event-registration" element={<EventRegistrations />} />
              <Route path="aicis/affiliate-purchases" element={<AffiliatePurchases />} />
              <Route path="aicis/settings" element={<Settings />} />
              <Route path="abvig" element={<AbvigDashboard />} />
              <Route path="abvig/contact-messages" element={<ContactMessages />} />
              <Route path="abvig/intern-applications" element={<InternApplications />} />
              <Route path="abvig/partnerships" element={<Partnerships />} />
              <Route path="abvig/subscribers" element={<Subscribers />} />
            </Route>
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;